// extracted by mini-css-extract-plugin
export default {"addNewMember":"addNewMember_addNewMember__zysBP","modalBody":"addNewMember_modalBody__IyHXq"};